export const AUTH_ROUTES = {
  path: 'auth',
  login: {
    path: 'login',
    data: {
      breadcrumb: 'LOGIN.TITLE',
      clickable: false
    }
  },
  register: {
    path: 'register',
    data: {
      breadcrumb: 'REGISTER.TITLE',
      clickable: false
    }
  },
  codeValidation: {
    path: 'code-validation',
    data: {
      breadcrumb: 'CODE_VALIDATION.TITLE',
      clickable: false
    }
  },
  passwordReset: {
    path: 'password-reset',
    data: {
      breadcrumb: 'PASSWORD_RESET.TITLE',
      clickable: false
    }
  }
};
